import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LanguageIcon from '@mui/icons-material/Language';
import MUIMenu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Button from '../Button';
import { getLanguageOptions } from '@Utilities/services/options';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { variantPropMap } from './services';
import './styles/languageSelect.scss';

export default function LanguageSelect({
  locale,
  onLocaleSelect,
  localized,
  variant
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const languageOptions = getLanguageOptions(localized);
  const isOpen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    event && event.preventDefault();
    setAnchorEl(null);
  };
  const getLanguageText = () => {
    if (locale === 'fr-CA') return 'Fr';
    return 'En';
  };
  const handleLocaleSelect = (event, selectedLocale) => {
    event && event.preventDefault();
    onLocaleSelect && onLocaleSelect(selectedLocale);
    handleClose();
  };

  return (
    <div className='language-select'>
      <Button
        className={`language-select__button ${variantPropMap?.[variant]?.btnClassName || ''}`}
        size='medium'
        variant='text'
        onClick={handleClick}
        data-testid='language-select-button'
      >
        <div className='language-select__button__icon'>
          <LanguageIcon />
        </div>
        <div className='language-select__button__text'>{getLanguageText()}</div>
        <div className='language-select__button__dropdown'>
          <KeyboardArrowDownIcon />
        </div>
      </Button>
      <MUIMenu
        className='language-select__menu'
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        MenuListProps={{
          className: 'language-select__menu__list'
        }}
      >
        {languageOptions.map((option) => (
          <MenuItem
            key={`header-language-select-${option.value}`}
            className='language-select__menu__list__item'
            onClick={(event) => handleLocaleSelect(event, option.value)}
          >
            {option.label}
          </MenuItem>
        ))}
      </MUIMenu>
    </div>
  );
}

LanguageSelect.propTypes = {
  localized: PropTypes.object,
  locale: PropTypes.string,
  onLocaleSelect: PropTypes.func.isRequired,
  variant: PropTypes.string
};
